import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import AdminDetectedPage from './pages/AdminDetectedPage';
import NotFoundPage from './pages/NotFoundPage';
import HomePage from './pages/HomePage';
import CoachesPage from './pages/CoachesPage';
import CoachDetailsPage from './pages/CoachDetailsPage';
import StudentsPage from './pages/StudentsPage';
import StudentDetailsPage from './pages/StudentDetailsPage';
import StudentRequestsPage from './pages/StudentRequestsPage';
import SessionsPage from './pages/SessionsPage';
import ReviewsPage from './pages/ReviewsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import PayoutsPage from './pages/PayoutsPage';
import MessagesPage from './pages/MessagesPage';
import ProtectedRoute from './components/ProtectedRoute';
import { CoachProvider } from './context/CoachContext';
import { StudentProvider } from './context/StudentContext';
import { ToastProvider } from './components/Toast/ToastContainer';

const App = () => {
  return (
    <ToastProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin-detected" element={<AdminDetectedPage />} />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <CoachProvider>
                <StudentProvider>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/coaches" element={<CoachesPage />} />
                      <Route path="/coaches/:id" element={<CoachDetailsPage />} />
                      <Route path="/students" element={<StudentsPage />} />
                      <Route path="/students/:id" element={<StudentDetailsPage />} />
                      <Route path="/requests" element={<StudentRequestsPage />} />
                      <Route path="/sessions" element={<SessionsPage />} />
                      <Route path="/reviews" element={<ReviewsPage />} />
                      <Route path="/reports" element={<ReportsPage />} />
                      <Route path="/payouts" element={<PayoutsPage />} />
                      <Route path="/messages" element={<MessagesPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </Layout>
                </StudentProvider>
              </CoachProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </ToastProvider>
  );
};

export default App;
